import { render, staticRenderFns } from "./AlacakList.vue?vue&type=template&id=74edb382"
import script from "./AlacakList.vue?vue&type=script&lang=ts"
export * from "./AlacakList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports